<div class="container">
  <div class="detalleDeMovimiento">
    <div *ngIf="loading" style="width: 100%; display: flex; justify-content: center; align-items: flex-start">
      <img style="border-radius: 57px" src="assets/icons/logo-fiser-loading.gif" alt="" width="150px" />
    </div>
    <div *ngIf="!loading && data" class="cuerpo">
      <div *ngIf="!isRefund">
        <div>
          <button mat-button color="primary" style="padding: 0 10px 0 0" (click)="goBackToList()">
            <img class="sizeIcon" src="assets/icons/exit.svg" />
            <span style="font-size: 16px">Volver</span>
          </button>
        </div>

        <span class="detalleDeMovimiento-titulo">Detalle de operación</span>

        <div class="card-container principal-header-card">
          <div class="principal-header-first-line">
            <div class="icon-title-wrapper">
              <img alt="" [src]="getIcon().iconURL" width="40px" height="30px" />
              <span class="principal-header-card-tipo">
                <b>{{ tipoTransaccion }}</b>
              </span>
            </div>
            <span class="principal-header-card-fecha">{{ data?.fecha | date : 'dd/MM/yyyy HH:mm:ss' }} </span>
          </div>

          <div class="principal-header-second-line">
            <div class="principal-header-card-monto-container">
              <span
                >Monto <span *ngIf="!isRefundType() && !isPCTType()">cobrado</span>:
                <b>{{ data?.importe | customCurrency }}</b>
              </span>
              <span *ngIf="showNeto()"
                >Neto acreditado: <b>{{ data?.netoAcreditado | customCurrency }}</b></span
              >
            </div>

            <div class="movement-card-badge">
              <span [ngClass]="setClassEstado(data?.estado)">
                {{ data?.estado }}
              </span>
            </div>
          </div>
        </div>

        <div class="card-container infoTransferenciaDetail">
          <!-- debin -->
          <span class="infoTransferenciaDetailItem" *ngIf="data?.debinId?.length === 22">
            <span id="nroOp"
              >{{ data?.debinId?.length === 22 ? 'DEBIN ID :' : '' }}
              <b>{{ data?.debinId?.length === 22 ? data?.debinId : '' }}</b>
            </span>
            <button style="background: transparent; margin: 0px 5px; padding: 0px" matTooltip="Copiar">
              <img
                class="iconCopy detalleDeMovimiento-info-operacion-id"
                (click)="copyNroOp(data?.debinId)"
                alt="copy"
                src="assets/icons/copy.svg"
              />
            </button>
          </span>
          <!-- Destinatario -->
          <span class="infoTransferenciaDetailItem" *ngIf="!recibeTransferencia">
            <span style="margin-left: 0" *ngIf="!isPixType()">Destinatario:</span>
            <span style="margin-left: 0" *ngIf="isPixType()">Origen:</span>
            <span style="font-weight: bold; font-size: 16px" [innerHTML]="data?.titulo"></span>
          </span>
          <!-- Remitente -->
          <span class="infoTransferenciaDetailItem" *ngIf="recibeTransferencia">
            Remitente:
            <span style="font-weight: bold; font-size: 16px" [innerHTML]="data?.titulo"></span>
          </span>
          <!-- DNI/CUIT -->
          <span *ngIf="!isPixType()" class="infoTransferenciaDetailItem">
            {{ data?.cuilCuitContraparte && data?.cuilCuitContraparte.length > 8 ? 'CUIL/CUIT' : 'DNI' }}:
            <b>{{ data?.cuilCuitContraparte ? maskCuit(data?.cuilCuitContraparte) : 'No especificado' }}</b>
          </span>
          <!-- CVU -->
          <span class="infoTransferenciaDetailItem" *ngIf="!isPixType() && data?.cvuContraparte">
            CVU:<b>{{ data?.cvuContraparte }}</b>
          </span>
          <span class="infoTransferenciaDetailItem">
            Número de operación: <b>#{{ data?.id }}</b>
          </span>
          <span *ngIf="isRechazadoMovement(data.estado)" class="infoTransferenciaDetailItem">
            Motivo: <b>{{ data?.observaciones | titlecase }}</b>
          </span>
          <span *ngIf="isPixType() && data.phoneClientPix" class="infoTransferenciaDetailItem">
            Teléfono: <b>{{ formatPhone(data.phoneClientPix) }}</b>
          </span>
          <span
            *ngIf="
              isPixType() && data.fechaAcreditacion && (data.estado === 'Aprobado' || data.estado === 'Acreditado')
            "
            class="infoTransferenciaDetailItem"
          >
            Fecha de acreditación:
            <b>{{ data.fechaAcreditacion ? (data.fechaAcreditacion | date : 'dd/MM/yyy') : '' }}</b>
          </span>
          <span *ngIf="isPixType() && data?.argExchangePix" class="infoTransferenciaDetailItem">
            Tasa de cambio: <b>{{ maskPrice(data.argExchangePix) }}</b>
          </span>
        </div>

        <mat-accordion class="accordion-group">
          <mat-expansion-panel class="card-container panel-item" *ngIf="dataPaymentDetail?.length > 0">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <span style="font-size: 20px; color: #ff6600"
                  ><b>{{ tituloMovimiento }}</b></span
                >
              </mat-panel-title>
            </mat-expansion-panel-header>
            <span *ngIf="dataPaymentDetail?.length < 1">¡No tiene {{ tituloMovimiento }}!</span>
            <!-- Vista cards mobile -->
            <div style="width: 100%; text-align: center" *ngIf="showTotalDescuentos(dataPaymentDetail)">
              <span style="font-weight: bold; font-size: 16px"
                >Total:
                <span style="font-weight: bold; color: #ff6600">{{ totalDescuentos | customCurrency }}</span>
              </span>
            </div>
            <div class="card-responsive-sm" style="margin-top: 16px">
              <div class="card-operation-detail-list-item" *ngFor="let result of dataPaymentDetail">
                <div>
                  <span>{{ result.titulo }}</span>
                  <span style="justify-content: flex-end"
                    ><strong>
                      {{ result.monto | customCurrency }}
                    </strong></span
                  >
                </div>
                <div>
                  <span
                    [ngClass]="setClassEstadoMovDetalleMovimiento(result.estado)"
                    [innerHTML]="setEstadoMovDetalleMovimiento(result.estado)"
                  ></span>
                  <span style="justify-content: flex-end"
                    >{{ result.fecha | date : 'd/M/yy' }} | Hora: {{ result.fecha | date : 'H:mm' }}</span
                  >
                </div>
              </div>
            </div>
            <!-- Vista tabla desktop -->
            <div class="card-container table-responsive-xl" style="margin-top: 16px">
              <table class="table" *ngIf="dataPaymentDetail?.length > 0">
                <thead>
                  <tr>
                    <th scope="col">ID Operación</th>
                    <th scope="col">Transaccion realizada por</th>
                    <th scope="col">Fecha</th>
                    <th scope="col">Estado</th>
                    <th scope="col">Monto</th>
                    <th scope="col">Titular</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let result of dataPaymentDetail">
                    <td>#{{ result.id }}</td>
                    <td>
                      <span *ngIf="!showLink()">{{ result.titulo }}</span>
                      <a *ngIf="showLink()" class="link-detail" (click)="showOriginalMovement(result.id)">{{
                        result.titulo
                      }}</a>
                    </td>
                    <td>
                      {{ result.fecha | date : 'd/M/yy' }} | Hora:
                      {{ result.fecha | date : 'H:mm' }}
                    </td>
                    <td
                      [ngClass]="setClassEstadoMovDetalleMovimiento(result.estado)"
                      [innerHTML]="setEstadoMovDetalleMovimiento(result.estado)"
                    ></td>
                    <td style="display: flex; justify-content: flex-end">
                      {{ result.monto | customCurrency }}
                    </td>
                    <td>{{ result.titularNombre }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </mat-expansion-panel>
          <mat-expansion-panel
            *ngIf="dataReturnsDetail?.length > 0 && (!isRefundType || !this.recibeTransferencia)"
            class="card-container panel-item"
            (opened)="panelOpenState = true"
            (closed)="panelOpenState = false"
          >
            <mat-expansion-panel-header>
              <mat-panel-title>
                <span style="font-size: 20px; color: #ff6600"><b> Devoluciones </b></span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <span *ngIf="dataReturnsDetail?.length < 1">¡No tiene Devoluciones!</span>
            <!-- Vista cards mobile -->
            <div style="width: 100%; text-align: center" *ngIf="showTotalDescuentos(dataReturnsDetail)">
              <span style="font-weight: bold; font-size: 16px"
                >Total:
                <span style="font-weight: bold; color: #ff6600">{{ totalDevoluciones | customCurrency }}</span>
              </span>
            </div>
            <div class="card-responsive-sm" style="margin-top: 16px">
              <div class="card-operation-detail-list-item" *ngFor="let result of dataReturnsDetail">
                <div>
                  <span>{{ result.titulo }}</span>
                  <span style="justify-content: flex-end"
                    ><strong>
                      {{ result.monto | customCurrency }}
                    </strong></span
                  >
                </div>
                <div>
                  <span
                    [ngClass]="setClassEstadoMovDetalleMovimiento(result.estado)"
                    [innerHTML]="setEstadoMovDetalleMovimiento(result.estado)"
                  ></span>
                  <span style="justify-content: flex-end"
                    >{{ result.fecha | date : 'd/M/yy' }} | Hora: {{ result.fecha | date : 'H:mm' }}</span
                  >
                </div>
              </div>
            </div>
            <!-- Vista tabla desktop -->
            <div class="card-container table-responsive-xl" style="margin-top: 16px">
              <table class="table" *ngIf="dataReturnsDetail?.length > 0">
                <thead>
                  <tr>
                    <th scope="col">ID Operación</th>
                    <th scope="col">Devolución realizada por</th>
                    <th scope="col">Fecha</th>
                    <th scope="col">Estado</th>
                    <th scope="col">Monto</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let result of dataReturnsDetail">
                    <td>#{{ result.id }}</td>
                    <td>{{ result.titulo }}</td>
                    <td>
                      {{ result.fecha | date : 'd/M/yy' }} | Hora:
                      {{ result.fecha | date : 'H:mm' }}
                    </td>
                    <td
                      [ngClass]="setClassEstadoMovDetalleMovimiento(result.estado)"
                      [innerHTML]="setEstadoMovDetalleMovimiento(result.estado)"
                    ></td>
                    <td style="display: flex; justify-content: flex-end; padding-right: 20px">
                      {{ result.monto | customCurrency }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>

      <div>
        <div *ngIf="isRefund" style="width: 100%">
          <form [formGroup]="form">
            <div class="devolver-total">
              <mat-checkbox
                [checked]="isChecked"
                [disabled]="presentRefunds"
                (change)="checkEvent($event.checked)"
                class="devolver-total-checkbox"
              >
                Devolver el total</mat-checkbox
              >
            </div>

            <div class="devolver-parcial">
              <span [ngClass]="{ 'desactivado-titulo': habilitarForm }">Devolución parcial</span>
            </div>

            <div class="devolver-parcial-monto">
              <span [ngClass]="{ 'desactivado-monto': habilitarForm }" class="devolver-parcial-monto-titulo"
                >Monto</span
              >
              <mat-form-field class="w-100">
                <input
                  matInput
                  #inputCash
                  [ngModel]="cashOutInputCurrency"
                  [disabled]="habilitarForm"
                  [readonly]="habilitarForm"
                  formControlName="monto"
                  autocomplete="off"
                  (keyup)="onKeyup($event)"
                  type="tel"
                  [ngClass]="{ 'desactivado-input': habilitarForm }"
                  class="devolver-parcial-monto-input"
                />
                <mat-hint *ngIf="isErrorMax">El importe no puede ser mayor al valor original</mat-hint>
              </mat-form-field>
            </div>

            <div class="devolver-parcial-monto-anterior">
              <span>Saldo restante para devolver: {{ infoPayment.saldo }}</span>
            </div>

            <div style="display: flex; justify-content: flex-end; margin-top: 1rem">
              <button mat-button style="margin-right: 1rem" (click)="goBack()">Cancelar</button>
              <button
                *ngIf="!habilitarForm"
                mat-raised-button
                color="primary"
                [disabled]="buttonStatus()"
                (click)="submitRefund(true)"
              >
                Aceptar
              </button>
              <button
                *ngIf="habilitarForm"
                mat-raised-button
                color="primary"
                [disabled]="presentRefunds"
                (click)="submitRefund(false)"
              >
                Aceptar
              </button>
            </div>
          </form>
        </div>
      </div>

      <div class="detalleDeMovimiento-buttons">
        <button
          mat-button
          color="primary"
          *ngIf="showPrintButton(data.estado, data?.conceptoTipo, data.mpTipo.id)"
          (click)="printTkt()"
          [disabled]="downloadLoading"
          class="detalleDeMovimiento-buttons-imprimir buttons-footer p-2"
          style="border: 2px solid #ff6600"
          type="button"
        >
          <ng-container *ngIf="downloadLoading; else printText">
            <div class="spinner-text-small">
              <mat-progress-spinner class="spinner-small" [diameter]="20" mode="indeterminate"></mat-progress-spinner>
            </div>
          </ng-container>
          <ng-template #printText>
            <div class="d-inline-flex align-items-center gap-3 pt-1">
              <mat-icon class="icon-print" *ngIf="environment === deviceEnvironmentId.CLOVER">print</mat-icon>
              <mat-icon class="icon-print" *ngIf="environment !== deviceEnvironmentId.CLOVER">download</mat-icon>
              {{ textButton }}
            </div>
          </ng-template>
        </button>
        <button
          mat-raised-button
          color="primary"
          *ngIf="evaluarMov(data)"
          class="detalleDeMovimiento-buttons-devolver buttons-footer"
          type="button"
          (click)="showRefund(data)"
        >
          Devolver pago
        </button>
      </div>
    </div>
  </div>
</div>
